// greeting-model.js

import { Model } from 'backbone';
import Immutable from 'immutable';

class GreetingModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default GreetingModel;
